import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getUserStatusAction } from '~/shared/store/user/actions'
import { selectUserStatus, selectUserUUID } from '~/shared/store/user/selects'

export const useSetUserStatus = () => {
  const dispatch = useDispatch()
  const uuid = useSelector(selectUserUUID)
  const userStatus = useSelector(selectUserStatus)

  useEffect(() => {
    if (uuid && !userStatus) {
      dispatch(getUserStatusAction(uuid))
    }
  }, [dispatch, uuid, userStatus])
}
